import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
/**
 * Created by h3 on 2018-09-06.
 */
import {Elastic, Linear, TimelineLite, TweenLite} from "gsap";
import {FruitsLayerConfig} from "../../../config/FruitsLayerConfig";
import {Fruits} from "../../Fruits";
import {FruitsGameModuleConfig} from "../../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";


export class FruitsBigWinCountUp extends BaseView {


    protected _countUp:BitmapCountUp;
    protected _countUpContainer:PIXI.Container;
    private _whiteCountUp:BitmapCountUp;
    private _countUpContainerWhite:PIXI.Container;
    private _endAnimationOffset:number;
    private _screenWidth:number;
    private _layer:ScalableLayer;

    constructor() {
        super();

        this._layer = StageManager.getLayer(FruitsLayerConfig.HIGH_ORDER_LAYER.name)
    }


    protected initAnimations():void {

        this._countUpContainer = new PIXI.Container();
        this._countUpContainer.pivot.set(0.5, 0.5);


        this._countUpContainerWhite = new PIXI.Container();
        this._countUpContainerWhite.pivot.set(0.5, 0.5);

        this.createCountUpFont();
        this.createWhiteCountUp();

        this._countUpContainer.addChild(this._countUp);
        this._countUpContainerWhite.addChild(this._whiteCountUp);

        this.addChild(this._countUpContainer);
        this.addChild(this._countUpContainerWhite);
    }

    protected onResize(resizeData:IResizeData):void {

        this._endAnimationOffset = resizeData.orientation === Orientation.LANDSCAPE ? resizeData.height * 0.5 : resizeData.height * 0.8;
        this._screenWidth = resizeData.width / this._layer.scale.x;

        if(this._countUp) {
            this._countUp.maxTextWidth = (this._screenWidth * 0.9);

        }

        if(this._whiteCountUp) {
            this._whiteCountUp.maxTextWidth = (this._screenWidth * 0.9);
        }

        if(super.onResize) {
            super.onResize(resizeData);
        }
    }

    private createCountUpFont():void {
        this._countUp = new BitmapCountUp({
            style : {font : {name : "Win_Numbers_A", size : 32}}
        });

        this._countUp.shrinkSize = true;
        this._countUp.visible = false;

    }

    private createWhiteCountUp():void {
        this._whiteCountUp = new BitmapCountUp({
            style : {font : {name : "Win_Numbers_D", size : 32}}
        });

        this._whiteCountUp.shrinkSize = true;
        this._whiteCountUp.visible = false;
    }

    private updateBitmapFont(level:number):void {
        let letter = "A";
        if(level === 0) {
            letter = "A";
        } else if(level === 1) {
            letter = "B";
        } else if(level >= 2) {
            letter = "C";
        }

        this._countUp.fontName = `Win_Numbers_${letter}`;
        this._countUp.fontSize = 32;

    }

    private flashFont(from:number, to:number, duration?:number):TimelineLite {

        const tl:TimelineLite = new TimelineLite();

        let dur = duration ? duration : 0;

        tl.add([
            this._whiteCountUp.getCountUpAnimation(from, to, {
                duration : dur,
                ease : Linear.easeNone
            }),
            () => this._whiteCountUp.visible = true,
        ]);
        tl.add(TweenLite.to(this._whiteCountUp, 0.5, {alpha : 0}), 0.25);
        tl.add(() => {
            this._whiteCountUp.visible = false;
            this._whiteCountUp.alpha = 1;
        });

        return tl;
    }

    private scaleFont():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            TweenLite.to(this._countUpContainer.scale, 0.15, {x : 1.2, y : 1.2}),
            TweenLite.to(this._countUpContainerWhite.scale, 0.15, {x : 1.2, y : 1.2})
        ]);
        tl.add([
            TweenLite.to(this._countUpContainer.scale, 0.35, {x : 1, y : 1}),
            TweenLite.to(this._countUpContainerWhite.scale, 0.35, {x : 1, y : 1})
        ]);

        return tl;
    }

    public getCountUpAnimation(from:number, to:number, duration:number, level:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(level > 0) {
            this.updateBitmapFont(level);
        }

        tl.add([

            this.flashFont(from, to, duration),
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration : duration,
                ease : Linear.easeNone
            }),
            this.scaleFont()
        ]);

        return tl;
    }

    private getAbortCountup(endValue:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            TweenLite.fromTo(this._countUpContainer.scale, 0.2,
                {x : 0.5, y : 0.5},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01}),
        ]);

        return tl;
    }

    public getEndingAnimation(endValue:number, winLevel:number, isAborted:boolean):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(isAborted) {
            tl.add(this.getAbortCountup(endValue));
            tl.add([
                () => FruitsBigWinCountUp.stopBigWinSound(winLevel),
                this.flashFont(endValue, endValue),
                Fruits.bigWinView.thirdLevelAnimation(),
                Fruits.bigWinView.fadeOutBg()
            ]);
            return tl;

        }
        tl.add([
            this.flashFont(endValue, endValue),
            () => FruitsBigWinCountUp.stopBigWinSound(winLevel),
            Fruits.bigWinView.firstLevelAnimation()
        ]);
        tl.add([
            () => SlotGame.sound.playEffect(FruitsSoundConfig.BIG_WIN_ENDS_HIT_2),
            this.flashFont(endValue, endValue),
            Fruits.bigWinView.secondLevelAnimation()
        ]);
        tl.add([
            () => SlotGame.sound.playEffect(FruitsSoundConfig.BIG_WIN_ENDS_HIT_3),
            this.flashFont(endValue, endValue),
            Fruits.bigWinView.thirdLevelAnimation()
        ], "-= 0.5");
        /*tl.add([
            TweenLite.to(this._countUpContainer.scale, 0.25, {x: 0, y: 0}),
            TweenLite.to(this._countUpContainer.position, 0.25 , {y: `+=${this._endAnimationOffset}`}),

        ]);*/
        tl.add(Fruits.bigWinView.fadeOutBg());

        return tl;
    }

    public resetBigWinCountUp():void {
        this._countUp.visible = false;
        this._whiteCountUp.visible = false;

        this._countUpContainer.position.set(0, 0);
        this._countUpContainer.scale.set(1, 1);
        this._countUp.alpha = 1;
        this._countUp.fontName =  `Win_Numbers_A`;
        this._countUp.fontSize = 32;

        this._whiteCountUp.alpha = 1;
        this._countUpContainerWhite.position.set(0, 0);
        this._countUpContainerWhite.scale.set(1, 1);

    }

    public fadeOutBigWinCountUp():void {
        const tl:TimelineLite = new TimelineLite();
        tl.add(TweenLite.to(this._countUp, 0.4, {alpha : 0}), "+= 0.8");
        tl.add(() => this.resetBigWinCountUp());
    }

    private static stopBigWinSound(winLevel:number):void {
        FruitsGameModuleConfig.soundHandler.playBigWinEndSound(winLevel);
        SlotGame.sound.stopEffect(FruitsSoundConfig.BIG_WIN);
        SlotGame.sound.fadeAmbience(1, 10000);
    }
}